import { getIn } from 'formik'
import { useContext } from 'react'
import { useTranslation } from 'react-i18next'
import Select from 'react-select'
import { Button, Col, Label, Row } from 'reactstrap'
import ai from '../../api/ai/hooks'
import { SelectOption } from '../../api/globalTypes'
import { realEstateDescriptionFields } from '../../common/forms/generalRealEstate/fields'
import PropertyFormDescriptionContext from './PropertyFormDescriptionContext'

const PropertyFormDescriptionAI = () => {
    const { t } = useTranslation()
    const { formik, subform, selectOptions, selectOptionsLoading, id } = useContext(PropertyFormDescriptionContext)

    const { mutate: generateDescription, isPending } = ai.GenerateDescription.useMutation()

    const emphasis = getIn(formik.values?.[subform], realEstateDescriptionFields.PROPERTY_DESCRIPTION_EMPHASIS)
    const descriptionLang = getIn(formik.values?.[subform], realEstateDescriptionFields.PROPERTY_DESCRIPTION_LANG)

    const handleGenerateDescription = () => {
        generateDescription(
            { id, emphasis, descriptionLang },
            {
                onSuccess: (data) => {
                    formik.setFieldValue(`${subform}.${realEstateDescriptionFields.PROPERTY_TITLE}.${descriptionLang}`, data.title)
                    formik.setFieldValue(`${subform}.${realEstateDescriptionFields.PROPERTY_DESCRIPTION}.${descriptionLang}`, data.description)
                },
            }
        )
    }

    const getSelectValue = (fieldName: string) => {
        const formikValue = getIn(formik.values?.[subform], fieldName)
        return selectOptions[fieldName]?.find((option: SelectOption) => option.value === formikValue) ?? null
    }

    const handleChange = (option: SelectOption, fieldName: string) => {
        formik.setFieldValue(`${subform}.${fieldName}`, option?.value ?? '')
    }

    return (
        <>
            <h5>{t('form.property.description.ai.title')}</h5>
            <p>{t('form.property.description.ai.message')}</p>

            <Row>
                <Col xs={12} md={4} xxl={12}>
                    <Label for={realEstateDescriptionFields.PROPERTY_DESCRIPTION_EMPHASIS}>{t('form.property.description.ai.emphasis')}</Label>
                    <Select
                        options={selectOptions?.[realEstateDescriptionFields.PROPERTY_DESCRIPTION_EMPHASIS] ?? []}
                        value={getSelectValue(realEstateDescriptionFields.PROPERTY_DESCRIPTION_EMPHASIS)}
                        onChange={(e) => handleChange(e, realEstateDescriptionFields.PROPERTY_DESCRIPTION_EMPHASIS)}
                        inputId={realEstateDescriptionFields.PROPERTY_DESCRIPTION_EMPHASIS}
                        isClearable={true}
                        isLoading={selectOptionsLoading}
                        loadingMessage={() => t('app.common.loading')}
                        noOptionsMessage={() => t('form.common.select.noData')}
                        placeholder=""
                    />

                    <Label className="mt-3" for={realEstateDescriptionFields.PROPERTY_DESCRIPTION_LANG}>
                        {t('app.common.language')}
                    </Label>
                    <Select
                        options={selectOptions?.[realEstateDescriptionFields.PROPERTY_DESCRIPTION_LANG] ?? []}
                        value={getSelectValue(realEstateDescriptionFields.PROPERTY_DESCRIPTION_LANG)}
                        onChange={(e) => handleChange(e, realEstateDescriptionFields.PROPERTY_DESCRIPTION_LANG)}
                        inputId={realEstateDescriptionFields.PROPERTY_DESCRIPTION_LANG}
                        isClearable={true}
                        placeholder=""
                    />

                    <Button color="send" className="mt-3" onClick={handleGenerateDescription} disabled={!emphasis || !descriptionLang || isPending}>
                        {t('button.generate')}
                    </Button>
                </Col>
            </Row>
        </>
    )
}

export default PropertyFormDescriptionAI
